import { defineCustomElement as defineIonSlides } from '@ionic/core/components/ion-slides.js';
import { defineCustomElement as defineIonSlide } from '@ionic/core/components/ion-slide.js';
import { initialize } from '@ionic/core/components/index.js';

import { ApplicationElement, html } from '@crossiety/lit-components';
import style from './style.lit.css';

// Initializes the Ionic config and `mode` behavior
initialize();

//  Defines the `ion` web components
defineIonSlides();
defineIonSlide();

/**
 * The Slideshow component is adopted [ion-slide](https://ionicframework.com/docs/api/slides) component. Each slide can be swiped or dragged between. It's using [Swiper](https://swiperjs.com) framework with hardware accelerated transitions.

 *
 * @prop activeIndex - Internal property => Active slide number.
 * @prop length - Internal property => Total slides number.
 * @prop slides - Internal property => Array of slides inside slot.
 * @prop slideOpts - Internal property => Optional parameters to pass to the swiper instance. See [Swiper API](https://swiperjs.com/swiper-api) for valid options.
 *
 * @slot default - For images that will be used in slider
 *
 * @prop --slide-height - Slide height
 * @prop --pagination-height - Pagination height
 * @prop --pagination-margin - Pagination margin
 */

export default class SlideShow extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    activeIndex: { state: true },
    length: { state: true },
    slides: { state: true },
  };

  constructor() {
    super();
    this.slides = [];
    this.activeIndex = 1;
    this.slideOpts = { autoplay: false };
  }

  async handleSlideChange(e) {
    this.activeIndex = (await e.target.getActiveIndex()) + 1;
  }

  handleSlotChange(e) {
    this.slides = e.target.assignedElements({ flatten: true });
    this.length = this.slides.length;
  }

  renderLabel() {
    return html`<span>${this.activeIndex}/${this.length}</span>`;
  }

  renderSlideItem(slide) {
    return html`<ion-slide>${slide}</ion-slide>`;
  }

  renderItems() {
    return this.slides.map(slide =>
      this.renderSlideItem(slide.cloneNode(true))
    );
  }

  render() {
    return html`
      ${this.renderLabel()}
      <ion-slides
        .options=${this.slideOpts}
        pager
        @ionSlideWillChange=${this.handleSlideChange}>
        ${this.renderItems()}
      </ion-slides>
      <slot @slotchange=${this.handleSlotChange} hidden></slot>
    `;
  }
}

customElements.get('xs-slideshow') ||
  customElements.define('xs-slideshow', SlideShow);
